export const AGENCY_CASE_MANAGEMENT_DEFAULT_SORT = {
  sortedColumn: 'lastName',
  sortedColumnOrder: 'ascend'
}
